module.exports = __webpack_public_path__ + "img/calendar.004852bf.svg";